export enum VehicleUseEnum {
  PRIVATE = 'PRIVATE',
  PRIVATE_AND_BUSINESS = 'PRIVATE_AND_BUSINESS',
  BUSINESS = 'BUSINESS',
}

export const getVehicleUseLabel = (value: VehicleUseEnum): string => {
  switch (value) {
    case VehicleUseEnum.PRIVATE:
      return $localize`Privé`;
    case VehicleUseEnum.BUSINESS:
      return $localize`Professionnelle`;
    case VehicleUseEnum.PRIVATE_AND_BUSINESS:
      return $localize`Privé et trajets domicile-travail`;
    default:
      return '';
  }
};
